export default __webpack_public_path__ + "static/media/enter-organization-code.682b642d.png";